import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PublicPageShell } from "@/components/landing/PublicPageShell";
import { ChallengeMarketplaceSection } from "@/components/landing/ChallengeMarketplaceSection";
import { MultiDomainBossBattles } from "@/components/landing/marketplace/MultiDomainBossBattles";
import { AIChallengeBuilderSection } from "@/components/landing/AIChallengeBuilderSection";

export default function MarketplacePage() {
  const [trackStats, setTrackStats] = useState(null);

  useEffect(() => {
    api.get("/public/track-stats").then((r) => setTrackStats(r.data)).catch(() => {});
  }, []);

  // Deep-link support for AI Tools homepage cards, e.g. /marketplace#boss-battles
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 300);
    }
  }, []);

  return (
    <PublicPageShell>
      <div data-testid="marketplace-page">
        <div className="h-8" />
        <ChallengeMarketplaceSection trackStats={trackStats} />
        <MultiDomainBossBattles />
        <AIChallengeBuilderSection />
      </div>
    </PublicPageShell>
  );
}
